import { Stack, useMediaQuery, useTheme } from '@rabex-kit/rabex-ui';
import { useLocation } from 'react-router-dom';
import GoogleRegisterForm from '../../components/Register/Google';
import { useGoogleRegisterMutation } from '../../services/auth';
import { GoogleRegisterRequestBody } from '../../services/auth/types';
import MockUp from '../../static/images/png/MockUp.png';
import useFinishSignIn from '@/hooks/useFinishSignIn';
import handleSubmitError from '../../utils/authErrors';

const RegisterContainer = () => {
  const finishSignIn = useFinishSignIn();
  const { breakpoints } = useTheme();
  // Not rendered below lg, so phones never download the image.
  const isMobile = useMediaQuery(breakpoints.down('lg'));
  const location = useLocation();
  const [registerRequest, { isLoading, isSuccess }] =
    useGoogleRegisterMutation();

  const handleOnSubmit = (values: GoogleRegisterRequestBody) => {
    registerRequest(values)
      .unwrap()
      .then((res) =>
        // Like every other sign-in: stored, refreshed, counted, then back to the return page.
        finishSignIn(res.data, 'registration', location.state?.returnTo)
      )
      .catch(handleSubmitError);
  };

  return (
    <>
      <GoogleRegisterForm
        onSubmit={handleOnSubmit}
        isLoading={isLoading || isSuccess}
      />
      {!isMobile && (
        <Stack>
          <img src={MockUp} alt="mockup" />
        </Stack>
      )}
    </>
  );
};

export default RegisterContainer;
